export { AccordionWithImage } from "./accordion-with-image";
